import { get } from '@/api/core'
import { getProductOrientation, toBackendProjectCategory } from '@/helpers/productCategory'

export namespace statistic {
  export type StatisticQuery = {
    taskType?: 'landscape' | 'portrait'
    durationCategory?: ProjectModels.DurationCategory
  }

  export function getStatistic(
    mode: ProjectModels.ProjectCategory,
    query?: StatisticQuery
  ) {
    const backendMode = toBackendProjectCategory(mode)
    const defaultTaskType = getProductOrientation(mode) === 'portrait' ? 'portrait' : 'landscape'
    const params = {
      taskType: query?.taskType || defaultTaskType,
      projectCategory: backendMode,
      ...(query?.durationCategory ? { durationCategory: query.durationCategory } : {}),
    }
    return get<{
      data: Models.StatisticData
      scoreList: number[]
      scoreResult: {
        baseScoreList: number[]
        brandScoreList: number[]
        portraitRegularBaseScoreList?: number[]
        portraitRegularBrandScoreList?: number[]
        portraitSplashBaseScoreList?: number[]
        portraitSplashBrandScoreList?: number[]
      }
    }>(
      backendMode === 'survey'
        ? '/advert/statistic/survey/score'
        : '/advert/statistic/score',
      params
    )
  }


  /** 获取AIGC项目得分百分比 */
  export function getAigcProjectPercentage(projectId: number) {
    return get('/advert/statistic/aigc_percentile', { projectId })
  }
}
